import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.flags.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapGetters } from 'vuex';
import compact from 'lodash/compact';
import delay from 'lodash/delay';
import Heart from '~/components/atoms/Global/Heart.vue';
import ProductFlags from '~/components/organisms/Product/ProductFlags.vue';
import USE_MARKETPLACE from '~/const/marketplace';
import { FLASH_TIMER } from '~/const/timers';
var VARIANTS_DISPLAYED = 4;
export default {
  name: 'ProductItem',
  components: {
    Heart,
    ProductFlags
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    withVariants: {
      type: Boolean,
      default: false
    },
    withWishlist: {
      type: Boolean,
      default: true
    },
    isCategoryTemplate: {
      type: Boolean,
      default: false
    },
    noLazy: {
      type: Boolean,
      default: false
    },
    lazySeo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      touch: false,
      showSecondImage: false,
      hoverVariant: false,
      hoverVariantArea: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    lazyPoly() {
      return this.noLazy === false && this.lazySeo === false; // If there is no lazy props indications; polyfill lazyloading is selected by default
    },

    flagsDisplayed() {
      var flags = this.product.flags.filter(flag => flag.code !== 'FREE_SHIPPING' && flag.code !== 'IS_ON_SALES');
      var isRse = flags.some(flag => flag.code === 'IS_RSE');
      var numberOfFlagsDisplayed = isRse ? 2 : 1;
      return flags.slice(0, numberOfFlagsDisplayed);
    },
    flagsSales() {
      return this.product.flags.filter(flag => flag.code === 'IS_ON_SALES');
    },
    displayedVariants() {
      if (!this.product.variants[0].products.length) {
        return [];
      }
      var curProductVariant = {
        images: [this.product.images[0]],
        name: this.product.name,
        reference: this.product.reference,
        slug: this.product.slug
      };
      var variants = this.product.variants[0].products.slice(0, VARIANTS_DISPLAYED);
      variants.unshift(curProductVariant);
      return variants;
    },
    totalVariants() {
      if (this.product.variants[0].products.length < VARIANTS_DISPLAYED) {
        return false;
      }
      var result = this.product.variants[0].products.length - VARIANTS_DISPLAYED;
      if (result === 0 || result + 2 === 0) {
        return false;
      }
      return {
        desktop: result,
        mobile: result + 2
      };
    },
    variantsVisibility() {
      return this.withVariants && this.product.variants && this.product.variants.length && this.product.variants[0].count;
    },
    currentItem() {
      if (this.hoverVariant) {
        return this.hoverVariant;
      }
      return this.product;
    },
    formattedName() {
      return compact([this.currentItem.line ? this.currentItem.line.toUpperCase() : null, this.currentItem.quantity > 1 ? this.$t('lot', {
        x: this.currentItem.quantity
      }) : null, this.currentItem.name]).join(' - ');
    },
    currentPrice() {
      return this.product.price.sales.amount ? this.product.price.sales.formatted : this.product.price.base.formatted;
    },
    currentImage() {
      if (this.showSecondImage && this.product.images[1] && !this.hoverVariant) {
        return this.product.images[1];
      }
      if (this.hoverVariant) {
        return this.hoverVariant.images[0];
      }
      return this.product.images[0];
    },
    brandMarketplace() {
      return USE_MARKETPLACE(this);
    }
  }),
  methods: {
    toggleImage(state) {
      delay(() => {
        if (this.touch) return;
        this.showSecondImage = state;
      }, FLASH_TIMER);
    },
    goToProduct(event) {
      this.$emit('goToProduct', event);
    }
  }
};